import { getNotifications, markAsRead, markAsUnread, getRequestFailedToastMessage } from "./getNotifications"

export const Notifications = {
    getNotifications,
    markAsRead,
    markAsUnread,
    getRequestFailedToastMessage,
}